import { makeStyles } from '@material-ui/core/styles';
import { darkBlue, mediumLightBlue } from '@signaturit/react-components-library';

export const useActivationEmailModalStyles = makeStyles(() => ({
    langSelector: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    content: {
        textAlign: 'center',
    },
    img: {
        marginTop: 88,
        width: 336,
        height: 216,
    },
    title: { marginTop: 32, color: darkBlue },
    body: {
        color: mediumLightBlue,
        marginTop: 16,
        '&:last-child': {
            marginBottom: 127,
        },
    },
    link: {
        color: `${mediumLightBlue} !important`,
        textDecoration: 'underline !important',
    },
}));
